import React, { useState, useEffect } from 'react'
import { Container, Button } from 'react-bootstrap'
import Playgame from './Playgame'
import { Link } from 'react-router-dom'
import playgamedata from './Playgamedata'
import axios from "axios";


export default function Play() {
  const [users, setUsers] = useState([]);
  const [usersdata, setUsersdata] = useState([]);
  const [loading1, setLoading] = useState(false);

  const handleReload = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    loaduser();
  }, [])

  const loaduser = async () => {
    try {
      setLoading(true);

      const user_id = localStorage.getItem("userid");
      const dev_id = localStorage.getItem("dev_id");

      // let url = `${process.env.REACT_APP_API_URL}/POM_all_market.php`;
      let url = `${process.env.REACT_APP_API_URL}/get-market-list`;

      const requestData = {
        app_id: process.env.REACT_APP_API_ID,
        user_id: user_id,
        dev_id: dev_id
      };

      const response = await axios.post(url, requestData, {
        headers: {
          "Content-Type": "application/json"
        }
      });
      console.warn("rarara", response);

      if (response?.data.message.data) {
        console.warn("hhhh", response);

        setUsers(response?.data.message.data);
        console.warn("rarara", response.data.data);
      }

    } catch (error) {
      console.error("Error loading user:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleClick = (id, name) => {
    // localStorage.setItem('name1',users.name);
    // console.warn(users.name);
    window.location.href = `/Playgame?id=${id}&name=${name}`;
  };
  return (
    <>
      <section id="play" className='margin-bottom-88'>

        <div className="playsection">
          <Container>
            <div className="d-flex justify-content-center backgroundheadingdesign">
              <p className='mb-0'> All Games</p>
              {/* <button className='playgamess'>
              my Games
              </button> */}
            </div>
            <div className="bg-white border-radius-8">
              <div className="row">
                {users && users.map((user) => (
                  <div className="col-md-12">
                    <div className="gamebg market " >
                      <div className="d-flex justify-content-between gameplaybattle">
                        <div className="marketnamepaly marketnamelist1">
                          <h3 className='animate-charcter animationtittle markettitlename'>{user.name} </h3>
                          <div className="d-flex align-items-center">
                            <i class="clock bi bi-clock-fill"></i>
                            <p className='animate-charcter'>{user.open_time}</p> -
                            <p className='animate-charcter'>{user.time}</p>
                          </div>
                        </div>



                        <div className="d-flex align-items-center linkgamesforplay">

                          {user.is_play == 1 ?
                            <Button onClick={() => { handleClick(user.id, user.name); handleReload(); }} className='playgames playgames_btn'><h3 className='fs-13 animationtittle markettitlenam'>Play Games</h3></Button>
                            :
                            <Button className='timeout'>Time Out</Button>
                          }
                        </div>

                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Container>
        </div>
        {loading1 && (
          // <>
          // <div className="loader_roomcode">
          //   <img src={loader} alt="loader" />
          // </div>
          // </>
          <div className="spinner-wrapper">
            <div className="loadernew2"></div>
          </div>
        )}
      </section>




    </>
  )
}
